// Module
var code = "<react-login-help></react-login-help>";
// Exports
module.exports = code;